export function calculateDistanceSquared(p1: number[], p2: number[]) {

    const dx = p1[0] - p2[0]
    const dy = p1[1] - p2[1]

    return (dx * dx) + (dy * dy)

}

export function calculateDistance(p1: number[], p2: number[]) {
    return Math.sqrt(calculateDistanceSquared(p1, p2))
}

export function calculateAngle(center: number[], p1: number[], p2: number[]): number {

    p1 = [p1[0] - center[0], p1[1] - center[1]];

    let target = [p2[0] - center[0], p2[1] - center[1]];

    let angle = Math.atan2(target[1], target[0]) - Math.atan2(p1[1], p1[0]);
    if (angle < 0) angle += 2 * Math.PI;

    return angle;

}
